import type { StaticDataRouteOption } from "@tanstack/react-router"

import { SettingsNavigation } from "../SettingsNavigation/SettingsNavigation"
import { IssueTypeSettingsFieldsViewTopBar } from "./TopBar"

export const issueTypeFieldsViewStaticData: StaticDataRouteOption = {
	leftSlideOut: SettingsNavigation,
	topBar: IssueTypeSettingsFieldsViewTopBar,
}
